import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import { getItem, STORAGE_KEYS } from '../../../services/storage';

const EstadoRecibo = ({ estados = [], setRecibos, isLoading, actual, numRecibo, disabled }) => {
  const user = getItem(STORAGE_KEYS.USER);

  const handleOnChange = (e) => {
    setRecibos((prev) =>
      prev.map((recibo) => {
        if (recibo.NUM_Recibo === numRecibo) {
          return { ...recibo, IdEstado: Number(e.target.value) };
        }
        return recibo;
      }),
    );
  };

  return (
    <>
      {isLoading || estados.length === 0 ? (
        ''
      ) : (
        <Input
          type="select"
          name={numRecibo}
          id={numRecibo}
          onChange={handleOnChange}
          value={actual}
          style={{
            width: '93px',
            height: '30px',
            fontSize: '13px',
            padding: '5px',
            color: disabled ? '#6c757d' : 'inherit',
          }}
          disabled={user.profileObj.email === 'ajimenez@cedetecgroup.com' || disabled}
        >
          {estados.map((datos) => (
            <option key={datos.id} value={datos.id}>
              {datos.descripcion}
            </option>
          ))}
        </Input>
      )}
    </>
  );
};
EstadoRecibo.propTypes = {
  estados: PropTypes.array,
  setRecibos: PropTypes.func,
  isLoading: PropTypes.bool,
  actual: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  numRecibo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
};
export default EstadoRecibo;
